import { Store } from '@ms/yammer-data/dist/state/types';
import { PopupAuthenticator } from '@ms/yammer-web-authenticators';
import { ReduxTranslationsContextProvider } from '@ms/yammer-web-components/dist/translations';
import AppContainer from '@ms/yammer-web-core-ui/dist/components/AppContainer';
import GriffelNoopRendererProvider from '@ms/yammer-web-core-ui/dist/components/GriffelNoopRendererProvider';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import PageLogin from '../../../pages/PageLogin';
import { YammerEmbedState } from '../../../state/types';

interface LoginRendererOptions {
  readonly store: Store<YammerEmbedState>;
  readonly target: HTMLElement;
  readonly authenticator: PopupAuthenticator;
}

export type LoginRenderer = (options: LoginRendererOptions) => void;
export const loginRenderer: LoginRenderer = ({ store, target, authenticator }) => {
  const { getState } = store;
  const currentLocale = getState().i18n.currentLocale;

  render(
    <GriffelNoopRendererProvider>
      <Provider store={store}>
        <ReduxTranslationsContextProvider>
          <AppContainer locale={currentLocale}>
            <PageLogin authenticator={authenticator} />
          </AppContainer>
        </ReduxTranslationsContextProvider>
      </Provider>
    </GriffelNoopRendererProvider>,
    target
  );
};
